"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimerInfosView = exports.RepsInfosView = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

var _Text = require("../../Text");

var _Button = require("../../Button/Button");

var _Util = require("../../Util");

var _Theme = require("../../Theme");

var _TimerButton = _interopRequireDefault(require("../../Button/TimerButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Text = function Text(_ref) {
  var style = _ref.style,
      props = _objectWithoutProperties(_ref, ["style"]);

  return /*#__PURE__*/_react["default"].createElement(_Text.Text, _extends({
    style: [{
      color: "white"
    }, style]
  }, props));
};

var BlocTitleText = function BlocTitleText(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement(Text, {
    style: {
      fontSize: 32,
      fontWeight: 'bold'
    },
    color: _Theme.colors.primary
  }, children);
};

var RepsText = function RepsText(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/_react["default"].createElement(Text, {
    style: {
      fontSize: 32
    },
    color: "white"
  }, children);
};

var RepsUnit = function RepsUnit(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/_react["default"].createElement(Text, {
    style: {
      fontSize: 25
    },
    color: "white"
  }, children);
};

var TimerText = function TimerText(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/_react["default"].createElement(Text, {
    style: {
      fontSize: 50,
      fontWeight: 'bold'
    },
    color: "white"
  }, children);
};

var TitleText = function TitleText(_ref6) {
  var children = _ref6.children,
      props = _objectWithoutProperties(_ref6, ["children"]);

  return /*#__PURE__*/_react["default"].createElement(Text, _extends({
    style: {
      fontSize: 28
    },
    color: "white"
  }, props), children);
};

var infoStyle = _reactNative.StyleSheet.create({
  container: {
    position: 'relative',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
});

var RepsInfosView = function RepsInfosView(_ref7) {
  var blocTitle = _ref7.blocTitle,
      reps = _ref7.reps,
      title = _ref7.title,
      style = _ref7.style;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [infoStyle.container, style]
  }, blocTitle && /*#__PURE__*/_react["default"].createElement(BlocTitleText, null, blocTitle), /*#__PURE__*/_react["default"].createElement(RepsText, null, reps, /*#__PURE__*/_react["default"].createElement(RepsUnit, null, "x")), /*#__PURE__*/_react["default"].createElement(TitleText, {
    numberOfLines: 1
  }, title));
};

exports.RepsInfosView = RepsInfosView;

var TimerInfosView = function TimerInfosView(_ref8) {
  var blocTitle = _ref8.blocTitle,
      timer = _ref8.timer,
      timerStarted = _ref8.timerStarted,
      timerEndedOnce = _ref8.timerEndedOnce,
      onClickStart = _ref8.onClickStart,
      title = _ref8.title,
      style = _ref8.style;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [infoStyle.container, style]
  }, !timerStarted && /*#__PURE__*/_react["default"].createElement(_TimerButton["default"], {
    title: timerEndedOnce ? "Relancer le timer" : "Lancer le timer",
    timer: timer,
    onPress: onClickStart,
    color: "app-primary",
    style: {
      marginBottom: 10
    }
  }), timerStarted && /*#__PURE__*/_react["default"].createElement(TimerText, null, (0, _Util.renderTime)(timer, 'short')), blocTitle && /*#__PURE__*/_react["default"].createElement(BlocTitleText, null, blocTitle), /*#__PURE__*/_react["default"].createElement(TitleText, {
    numberOfLines: 1,
    ellipsizeMode: "tail"
  }, title));
};

exports.TimerInfosView = TimerInfosView;